<template>
  <v-container
    fluid
    class="roles-revamp roles-revamp--modern oms-list-page role-mapping-page"
  >
    <v-card raised class="oms-list-panel role-mapping-panel">
      <v-progress-linear
        indeterminate
        color="trukkin-theme darken-2"
        v-show="loading"
      ></v-progress-linear>
      <v-card-title primary-title class="bg-clr oms-page-header role-mapping-header">
        <v-btn fab flat icon class="nospace role-back-btn" @click.native="goback">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <div class="role-mapping-title-block">
          <span class="headline role-form-title">
            Create {{ this.mappingTypeMap[this.mappingType].title }}
          </span>
        </div>
      </v-card-title>
      <v-tabs centered color="transparent" icons-and-text class="role-mapping-tabs">
        <v-tabs-slider color="orange darken-1"></v-tabs-slider>

        <v-tab href="#tab-1">
          Assigned Roles
          <v-icon>assignment_ind</v-icon>
        </v-tab>

        <v-tab href="#tab-2">
          All Roles
          <v-icon>supervised_user_circle</v-icon>
        </v-tab>

        <v-tab-item :key="1" :value="'tab-1'">
          <v-card flat class="role-mapping-tab-card">
            <v-container
              fluid
              class="role-mapping-body"
              v-if="this.mappingData.userType"
            >
              <div class="role-mapping-context">
                <div class="role-mapping-user-type">
                  <span>User Type</span>
                  <strong>{{ this.mappingData.userType.userTypeTitle }}</strong>
                </div>
                <div class="role-mapping-legend">
                  <span class="role-mapping-legend__item">
                    <i class="role-mapping-legend__dot is-active"></i>
                    Enabled
                  </span>
                  <span class="role-mapping-legend__item">
                    <i class="role-mapping-legend__dot"></i>
                    Disabled
                  </span>
                </div>
              </div>

              <div class="role-mapping-content">
                <div
                  class="role-permission-card"
                  :key="roles._id"
                  v-for="roles in rolesItems"
                  v-if="roles.children && roles.children.length > 0"
                >
                  <div class="role-permission-card__header">
                    <h2>{{ roles.role.roleTitle }}</h2>
                    <span>{{ roles.children.length }} permissions</span>
                  </div>
                  <div class="role-switch-grid">
                    <v-switch
                      :key="j"
                      color="green"
                      class="switch-permission-type"
                      v-for="(data, j) in roles.children"
                      v-model="data.isChecked"
                      :label="` ${data.operationTitle.toString()}`"
                      @change="updateRole(data, 'sub-role', roles)"
                    ></v-switch>
                  </div>
                </div>

                <div class="not-found" v-if="!rolesItems.length">
                  <h1>No roles were found</h1>
                  <p>Please use the All Roles tab to assign roles.</p>
                </div>
              </div>
            </v-container>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="2" :value="'tab-2'">
          <v-card flat class="role-mapping-tab-card">
            <v-container
              fluid
              class="role-mapping-body"
              v-if="this.mappingData.userType"
            >
              <div class="role-mapping-context">
                <div class="role-mapping-user-type">
                  <span>User Type</span>
                  <strong>{{ this.mappingData.userType.userTypeTitle }}</strong>
                </div>
                <div class="role-mapping-legend">
                  <span class="role-mapping-legend__item">
                    <i class="role-mapping-legend__dot is-active"></i>
                    Assigned
                  </span>
                  <span class="role-mapping-legend__item">
                    <i class="role-mapping-legend__dot"></i>
                    Not assigned
                  </span>
                </div>
              </div>

              <div class="role-mapping-content">
                <div class="role-all-grid">
                  <v-switch
                    :key="i"
                    :readonly="loading"
                    color="green"
                    class="switch-permission-type"
                    v-for="(data, i) in this.allRoles.data"
                    v-model="data.isChecked"
                    :label="` ${data.roleTitle.toString()}`"
                    v-on:change="updateRole(data, 'role', 0)"
                  ></v-switch>
                </div>
              </div>
            </v-container>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>
<script>
import _ from "lodash";
import {
  getAllRoles,
  getAllOperations,
  assignOperationtoRole,
  assignRoletoUserType,
} from "../../constants/api-urls";
export default {
  created() {
    this.mappingType = this.$route.params.mappingType;
    this.id = this.$route.params.id;
    this.getRoles(this.id, "user-role");
    this.getAllRoles(this.id, this.mappingType);
  },
  watch: {
    selection(newValue) {},
  },
  data() {
    return {
      id: "",
      loading: false,
      selection: [],
      dense: false,
      selectable: false,
      activatable: false,
      hoverable: false,
      openOnClick: false,
      shaped: false,
      rounded: false,
      color: "primary",
      selectedColor: "accent",
      selectedColors: ["accent", "teal", "red", "success", "warning lighten-2"],
      activeOperations: [],

      assignedRole: [],
      assignedSubRole: [],
      switch1: true,
      selectable: true,
      mappingData: [],
      rolesItems: [],
      allRoles: [],
      subRoleItems: [],
      mappingType: "",
      mappingTypeMap: {
        "user-role": {
          name: "user-role",
          title: "User - Role Mapping",
        },
        "role-sub-role": {
          name: "role-sub-role",
          title: "Role - Sub Role Mapping",
        },
      },
      headers: [
        {
          text: "Sr No",
          sortable: false,
          value: "srno",
          class: "table-header-item",
        },
        {
          text: "Type",
          sortable: false,
          class: "table-header-item",
          value: "user-type",
        },
        {
          text: "Status",
          sortable: false,
          class: "table-header-item",
          value: "status",
        },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
          class: "table-header-item",
        },
      ],
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async showMapping(id, mappingType) {
      let url = "";
      if (mappingType == "user-role") {
        url = `/assignedRoletoUserType/${id}`;
      }
      if (mappingType == "role-sub-role") {
        url = `/assignedSubRoletoRole/${id}`;
      }

      this.loading = true;

      delete this.axios.defaults.headers.common["token"];

      const response = await this.axios.get(this.constants.rbacUrl + url);
      if (response.status == 200) {
        return response.data.data;
      } else {
        this.loading = false;
      }
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    async getRoles(id, mappingType) {
      this.loading = true;
      let url = getAllRoles;
      delete this.axios.defaults.headers.common["token"];

      let res = await this.axios.get(this.constants.rbacUrl + url);
      let data = await this.showMapping(id, mappingType);
      this.mappingData = data;

      let roles = [];
      if (data) {
        roles = data.roles.map((x) => x.role._id);
      }
      this.assignedRole = roles;
      roles.forEach((d1) => {
        for (let i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i]._id == d1) {
            res.data.data[i].isChecked = true;
          }
        }
      });
      this.allRoles = res.data;
    },
    async getAllRoles(id, mappingType) {
      if (mappingType == "user-role") {
        this.loading = true;
        let data = await this.showMapping(id, mappingType);
        this.mappingData = data;
        this.rolesItems = data.roles;
        let __roles__ = [];
        await this.asyncForEach(this.rolesItems, async (role, index) => {
          let operations = [];
          let children = await this.showMapping(role.role._id, "role-sub-role");
          await this.asyncForEach(children.subRole, async (subRole, i) => {
            await this.asyncForEach(role.operations, async (activeSubRole) => {
              if (subRole._id == activeSubRole._id) {
                children.subRole[i].isChecked = true;
              }
            });
          });
          operations = children.subRole;
          let obj = {
            userType: data.userType,
            role: role.role,
            children: operations,
          };
          __roles__.push(obj);
        });
        this.rolesItems = __roles__;
        this.loading = false;
      }
      if (mappingType == "role-sub-role") {
        let finalRes = [];

        this.loading = true;
        let url = getAllOperations;
        delete this.axios.defaults.headers.common["token"];

        let res = await this.axios.get(this.constants.rbacUrl + url);
        let data = await this.showMapping(id, mappingType);
        this.mappingData = data;
        let subRoles = data.subRole.map((x) => x._id);
        this.assignedSubRole = subRoles;
        subRoles.forEach((d1) => {
          for (let i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i]._id == d1) {
              res.data.data[i].isChecked = true;
            }
          }
        });
        this.subRoleItems = res.data;
      }
    },
    async updateRole(data, type, _roles) {
      this.loading = true;
      let roles = this.assignedRole;
      let obj = [];
      roles = [...new Set(roles)];

      if (!roles) {
        let _o = {
          roleId: data._id,
          operations: [],
        };

        obj.push(_o);
      } else {
        if (type == "role") {
          let done = true;

          if (this.rolesItems.length == 0) {
            let _o = {
              roleId: data._id,
              operations: [],
            };

            obj.push(_o);
          } else {
            await this.asyncForEach(this.rolesItems, async (_data) => {
              let subRoles = _data.children.filter((e) => e.isChecked == true);
              subRoles = subRoles.map((x) => x._id);
              let _o = {
                roleId: _data.role._id,
                operations: subRoles,
              };
              obj.push(_o);

              if (data.isChecked && done) {
                _o = {
                  roleId: data._id,
                  operations: [],
                };

                done = false;
                obj.push(_o);
              }
              if (!data.isChecked) {
                obj = obj.filter((x) => x.roleId != data._id);
              }
            });
          }
        } else {
          let done = true;
          await this.asyncForEach(this.rolesItems, async (_data) => {
            let subRoles = _data.children.filter((e) => e.isChecked == true);

            subRoles = subRoles.map((x) => x._id);
            let _o = {};
            if (_roles.role._id == _data.role._id) {
              if (data.isChecked && done) {
                subRoles.push(data._id);
                subRoles = [...new Set(subRoles)];
                _o = {
                  roleId: _roles.role._id,
                  operations: subRoles,
                };
                done = false;
              } else {
                _o = {
                  roleId: _data.role._id,
                  operations: subRoles,
                };
              }
            } else {
              _o = {
                roleId: _data.role._id,
                operations: subRoles,
              };
            }
            if (!_.isEmpty(_o)) {
              obj.push(_o);
            }
          });
        }
      }
      let body = {
        userTypeId: this.$route.params.id,
        roles: obj,
      };
      let url = assignRoletoUserType;
      this.axios.post(this.constants.rbacUrl + url, body).then(
        (response) => {
          if (type == "role") {
            this.getAllRoles(this.id, this.$route.params.mappingType);
          }

          this.loading = false;
        },
        (error) => {
          this.x.error = "Failed to Assign";
          this.loading = false;
        }
      );
    },
    async assignOperationToRole(roles, data) {
      let id = data._id;
      this.loading = true;
      let __operations = roles.children.map(({ _id }) => ({
        _id,
      }));
      let operations = [];
      await this.asyncForEach(__operations, async (operation) => {
        operations.push(operation._id);
      });

      let __assignedoperations = roles.active.map(({ _id }) => ({
        _id,
      }));
      let assignedOperations = [];
      await this.asyncForEach(__assignedoperations, async (operation) => {
        assignedOperations.push(operation._id);
      });
      if (data.isChecked) {
        assignedOperations.push(data._id);
      } else {
        assignedOperations = assignedOperations.filter((e) => e !== id);
      }

      // if (data.isChecked) {
      //     operations.push(data._id);
      // } else {
      //     var index = operations.indexOf(data._id);
      //     if (index > -1) {
      //         operations.splice(index, 1);
      //     }
      // }
      let body = {
        roleId: roles._id,
        operations,
        assignedOperations,
      };
      let url = assignOperationtoRole;
      this.axios.post(this.constants.rbacUrl + url, body).then(
        (response) => {
          this.getAllRoles(
            this.$route.params.id,
            this.$route.params.mappingType
          );
          this.loading = false;
        },
        (error) => {
          this.x.error = "Failed to Assign SubRole";
          this.loading = false;
        }
      );
    },
  },
};
</script>
<style scoped>
.switch-permission-type {
  align-items: center;
  display: flex;
  float: none;
  height: auto;
  margin: 0 !important;
  min-width: 0;
  padding: 0 !important;
  width: 100%;
}

.role-mapping-title-block {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.role-mapping-context {
  align-items: center;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  min-width: 0;
}

.role-mapping-user-type {
  background: var(--oms-primary-soft);
  border: 1px solid rgba(234, 122, 28, 0.22);
  border-radius: var(--oms-control-radius);
  display: inline-flex;
  flex-direction: column;
  gap: 0.1875rem;
  min-width: min(100%, 16rem);
  padding: 0.625rem 0.875rem;
  text-align: left;
}

.role-mapping-user-type span,
.role-mapping-legend__item {
  color: var(--oms-muted);
  font-size: 0.71875rem;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.25;
  text-transform: uppercase;
}

.role-mapping-user-type strong {
  color: var(--oms-ink-strong);
  font-size: 0.9375rem;
  font-weight: 800;
  line-height: 1.25;
}

.role-mapping-legend {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
}

.role-mapping-legend__item {
  align-items: center;
  display: inline-flex;
  gap: 0.375rem;
}

.role-mapping-legend__dot {
  background: var(--oms-border);
  border-radius: 999rem;
  display: inline-flex;
  height: 0.5rem;
  width: 0.5rem;
}

.role-mapping-legend__dot.is-active {
  background: #16a34a;
}

.role-mapping-content {
  display: grid;
  gap: 1rem;
  text-align: left;
}

.role-permission-card {
  background: var(--oms-surface);
  border: 1px solid var(--oms-border);
  border-radius: var(--oms-radius);
  box-shadow: none;
  overflow: hidden;
}

.role-permission-card__header {
  align-items: center;
  background: var(--oms-surface-soft);
  border-bottom: 1px solid var(--oms-border);
  display: flex;
  gap: 0.75rem;
  justify-content: space-between;
  min-width: 0;
  padding: 0.875rem 1rem;
}

.role-permission-card__header h2 {
  color: var(--oms-ink-strong);
  font-size: 0.9375rem;
  font-weight: 800;
  line-height: 1.25;
  margin: 0;
  min-width: 0;
}

.role-permission-card__header span {
  color: var(--oms-muted);
  flex: 0 0 auto;
  font-size: 0.75rem;
  font-weight: 700;
}

.role-switch-grid,
.role-all-grid {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 1rem;
}

.role-all-grid {
  background: var(--oms-surface);
  border: 1px solid var(--oms-border);
  border-radius: var(--oms-radius);
}

.not-found {
  text-align: center !important;
  background: var(--oms-surface);
  border: 1px dashed var(--oms-border);
  border-radius: var(--oms-radius);
  margin: 0 !important;
  padding: 2rem 1rem !important;
}

.not-found h1 {
  color: var(--oms-ink-strong);
  font-size: 1rem;
  font-weight: 800;
  margin: 0 0 0.375rem;
}

.not-found p {
  color: var(--oms-muted);
  font-size: 0.8125rem;
  margin: 0;
}

.role-mapping-page ::v-deep .switch-permission-type.v-input--switch {
  background: var(--oms-surface-soft);
  border: 1px solid var(--oms-border);
  border-radius: var(--oms-control-radius);
  box-sizing: border-box;
  min-height: 3rem;
  padding: 0.5rem 0.75rem !important;
}

.role-mapping-page ::v-deep .switch-permission-type .v-input__slot {
  align-items: center;
  margin: 0;
}

.role-mapping-page ::v-deep .switch-permission-type .v-label {
  color: var(--oms-ink);
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.25;
}

.role-mapping-page ::v-deep .switch-permission-type .v-messages {
  display: none;
}

@media (max-width: 76rem) {
  .role-switch-grid,
  .role-all-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 48rem) {
  .role-mapping-context {
    align-items: flex-start;
    flex-direction: column;
  }

  .role-mapping-legend {
    justify-content: flex-start;
  }

  .role-switch-grid,
  .role-all-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
